<template>
    <div>
        <b-table :fields="licitacao.IsLote ? fieldsLote : fieldsItem" :items="licitacao.IsLote ? lotes : itens"
            :busy="tableBusy" :current-page="currentPage" hover no-border-collapse sort-by="" :sort-desc="true"
            stacked="sm" show-empty>
            <template #empty>
                <span>Não foram encontrados dados.</span>
            </template>
            <template #emptyfiltered>
                <span>Não foram encontrados dados.</span>
            </template>
            <template v-slot:cell(detalhes)="row">
                <b-link class="text-dark" @click="row.toggleDetails">
                    <font-awesome-icon :icon="row.detailsShowing ? 'chevron-up' : 'chevron-down'" />
                </b-link>
            </template>
            <template #table-busy>
                <div class="text-center text-dark">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="loading-text">Carregando...</strong>
                </div>
            </template>
            <template #row-details="row">
                <detalhes-itens-do-lote :idLote="row.item.IdLoteLicitacao"></detalhes-itens-do-lote>
            </template>
            <template #custom-foot>
                <b-tr v-if="licitacaoVlTotalEstimado" class="font-weight-bold">
                    <b-td :colspan="licitacao.IsLote ? 4 : 5" class="text-right">Total estimado:</b-td>
                    <b-td class="text-right">
                        {{ licitacaoVlTotalEstimado ? formatMoeda(licitacaoVlTotalEstimado) : '' }}
                    </b-td>
                </b-tr>
            </template>
        </b-table>
        <table-pagination :total-rows=totalRows :per-page=pageSize @pageChange="pageChange" />
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { UtilsTS } from '@/utilsts'

import TablePagination from "@/components/atos-pessoal/TablePagination.vue";

import { fieldsItemLicitacao } from '@/types/licitacoes/ldi/fields-item-licitacao'
import { fieldsLoteLicitacao, detalhes } from '@/types/licitacoes/ldi/fields-lote-licitacao'

import { ItemLicitacao } from '@/types/licitacoes/ldi/item-licitacao'
import { LoteLicitacao } from '@/types/licitacoes/ldi/lote-licitacao'

import ldiService from '@/services/licitacoes/ldiService'
import { TableField } from '@/types/table-field'

import DetalhesItensDoLote from './DetalhesItensDoLote.vue'

const CompProps = Vue.extend({
    name: 'DetalhesLotesItens',
    components: { TablePagination, DetalhesItensDoLote },
    props: {
        licitacao: {
            type: Object,
            required: true
        }
    }
})

@Component
export default class DetalhesLotesItens extends mixins(UtilsTS, CompProps) {
    fieldsItem: TableField[] = fieldsItemLicitacao
    fieldsLote: TableField[] = [detalhes, ...fieldsLoteLicitacao]
    itens: ItemLicitacao[] = []
    lotes: LoteLicitacao[] = []

    //table-related
    currentPage = 1
    pageSize = 10
    totalRows = 0
    tableBusy = false
    licitacaoVlTotalEstimado: number | null = null

    async mounted(): Promise<void> {
        this.loadData()
    }

    async loadData(): Promise<void> {
        try {
            this.tableBusy = true

            if (this.licitacao.IsLote) {  //LOTES
                const response = await ldiService.buscarLotes(this.licitacao.IdLicitacao, this.currentPage, this.pageSize)
                if (response) {
                    this.lotes = response.lotes.map(l => {
                        const lote = Object.assign(new LoteLicitacao(), l)
                        return lote
                    })
                    this.totalRows = response.totalRows
                    this.licitacaoVlTotalEstimado = response.licitacaoVlTotalEstimado
                } else {
                    this.$toast.error('Erro ao consultar os lotes/itens de licitações.');
                }
            }
            else {  //ITENS
                const response = await ldiService.buscarItens(this.licitacao.IdLicitacao, this.currentPage, this.pageSize)
                if (response) {
                    this.totalRows = 0
                    this.itens = response.itens.map(l => {
                        const item = Object.assign(new ItemLicitacao(), l, l.NuSequencialItem = (this.pageSize * (this.currentPage - 1)) + ++this.totalRows)
                        return item
                    })
                    this.totalRows = response.totalRows
                    this.licitacaoVlTotalEstimado = response.licitacaoVlTotalEstimado
                } else {
                    this.$toast.error('Erro ao consultar os lotes/itens de licitações.');
                }
            }
        } catch (e: unknown) {
            console.error(e)
            this.$toast.error('Falha ao buscar lotes/itens. ' + e)
            this.limparDados()
        } finally {
            this.tableBusy = false;
        }
    }

    async pageChange(value: number): Promise<void> {
        this.currentPage = value;
        await this.loadData();
    }

    limparDados(): void {
        this.totalRows = 0
        this.itens = []
        this.licitacaoVlTotalEstimado = null
    }
}
</script>

<style></style>

<style scoped>
div.row>div>span:first-child {
    font-weight: bolder;
    display: block;
}
</style>